const postsEnglish = {
  header: {
    title: "My LinkedIn Posts",
    postsLeft: "{remaining}/{limit} posts left this week"
  },
  limitWarning: {
    used: "You have used all your {limit} weekly posts. Upgrade your subscription for more.",
    upgrade: "Upgrade subscription",
    low: "You have {remaining} posts left this week. Plan them carefully."
  },
  loading: "Loading posts...",
  noPostsMessage: {
    title: "No scheduled posts",
    help: "Use the Telegram bot to schedule new posts"
  },
  postCard: {
    date: "{date}",
    time: "{time}",
    status: {
      scheduled: "Scheduled",
      published: "Published"
    },
    image: "Image attached",
    actions: {
      share: "Share on LinkedIn",
      sharing: "Sharing...",
      delete: "Delete",
      deleting: "Deleting..."
    }
  },
  confirmation: {
    delete: "Are you sure you want to delete this post?"
  },
  result: {
    success: "Post shared on LinkedIn!",
    errorPrefix: "Error: ",
    postDeleted: "Post deleted!"
  },
  customerBanner: "You are viewing posts for {customerName}",
  calendar: {
    viewToggle: {
      month: "Month",
      week: "Week"
    },
    weekDays: {
      sunday: "Sunday",
      monday: "Monday",
      tuesday: "Tuesday", 
      wednesday: "Wednesday",
      thursday: "Thursday",
      friday: "Friday",
      saturday: "Saturday"
    },
    weekHeader: "Week {week} - {month} {year}",
    noTime: "No time"
  },
  modal: {
    title: "Post Details",
    sections: {
      content: "Content",
      schedule: "Scheduled Time",
      status: "Status",
      image: "Image"
    },
    schedule: {
      noTime: "No time scheduled",
      edit: "Edit",
      date: "Date",
      time: "Time",
      cancel: "Cancel",
      save: "Save"
    },
    status: {
      published: "Published",
      ready: "Ready for publishing",
      scheduled: "Scheduled", 
      unknown: "Unknown"
    },
    actions: {
      delete: "Delete Post",
      share: "Share on LinkedIn"
    }
  }
};

export default postsEnglish; 